import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import { useBottomNavBar } from "../contexts/BottomNavBarContext";
import affieGreyLarge from "../assets/affie-grey-large.svg";

const Error404: React.FC = () => {
  const navigate = useNavigate();
  const { setIsVisible } = useBottomNavBar();

  useEffect(() => {
    // Hide bottom nav bar when component mounts
    setIsVisible(false);
    // Show bottom nav bar when component unmounts
    return () => {
      setIsVisible(true);
    };
  }, [setIsVisible]);

  return (
    <div className="w-full h-[80vh] flex flex-col items-center justify-center bg-black rounded-20 p-4">
      <div className="flex-1 flex flex-col items-center justify-center text-center text-5xl lg:text-8xl max-full md:max-w-5xl">
        <div className="flex text-grey-80">
          <p>4</p>
          <img
            src={affieGreyLarge}
            alt="0"
            className="w-[53px] h-[52px] md:w-auto md:h-auto"
          />
          <p>4</p>
        </div>
        <h1 className="font-semibold text-white text-4xl">
          You've Hit A Dead End, But Not With Us.
        </h1>
        <Button
          text="Back to Home"
          variant="primary"
          onClick={() => navigate("/")}
          className="mt-12"
        />
      </div>
    </div>
  );
};

export default Error404;
